<template>
  <b-form-group>
    <label>{{ label }}</label>
    <v-select
      :name="name"
      :value="optionSelected"
      :options="entity"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      @input="onInput"
      :clearable="isClearable"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="loading"
          :style="{ opacity: loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay destinos para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      subjects: [],
      externDataForms: [
        'send-to-docdigital-form'
      ]
    };
  },
  computed: {
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('List', ['subjectTypesState']),
    ...mapGetters('docDigital', [
      'entity',
      'loading'
    ]),
    optionSelected() {
      return this.entity.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled
        || !this.entity.length;
    },
    hideOptions() {
      const formType = this.$route.path.split('/');
      return this.externDataForms.includes(formType[formType.length - 1]);
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event?.value);
    },
    getOption() {
      return this.entity.find((option) => option.value === this.value);
    }
  },
  props: {
    name: { type: String, required: true },
    label: { type: String, default: 'Tipo Destino' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    isClearable: { type: Boolean, default: true }
  }
};

</script>
